import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { buildAnnotationMarkDataAttributes } from '@atlaskit/adf-schema';
import { AnnotationMark } from '../../ui/annotations';
export const isAnnotationMark = mark => {
  return mark && mark.type && mark.type.name === 'annotation';
};
const AnnotationComponent = ({
  id,
  annotationType,
  children,
  dataAttributes,
  annotationParentIds = [],
  allowAnnotations,
  useBlockLevel
}) => {
  const data = {
    ...dataAttributes,
    ...buildAnnotationMarkDataAttributes({
      id,
      annotationType
    })
  };
  if (allowAnnotations) {
    return /*#__PURE__*/React.createElement(AnnotationMark, {
      id: id,
      dataAttributes: data,
      annotationParentIds: annotationParentIds,
      annotationType: annotationType,
      useBlockLevel: useBlockLevel
    }, children);
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    id: id
  }, data), children);
};
export default AnnotationComponent;